import { APIResponseType } from 'app/apiService/types';
import apiService from '..';

interface SidebarNavigationItem {
  label: string;
  link: string;
  icon: string;
  isDefault?: boolean;
  order?: number;
}

interface RolePayload {
  name: string;
  scopes: string[];
  group_can_be_attached?: boolean;
  list_can_be_attached?: boolean;
  access_to_all_dealership?: boolean;
  old_layout?: boolean;
  sidebar_navigation?: SidebarNavigationItem[];
}

class Role {
  static ENDPOINT = 'api/v2/roles';

  static async getRole(roleId: string): Promise<APIResponseType> {
    if (!roleId) throw new Error("Role ID is required to fetch details");
    try {
      const response = await apiService.get<APIResponseType>(`${this.ENDPOINT}/${roleId}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async getAllRoles(): Promise<APIResponseType> {
    try {
      const response = await apiService.get<APIResponseType>(`${this.ENDPOINT}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async addRole(payload: RolePayload): Promise<APIResponseType> {
    try {
      console.log("API Service - addRole called with payload:", payload);
      const response = await apiService.post<APIResponseType>(`${this.ENDPOINT}`, payload);
      await apiService.invalidateCacheByPrefix(this.ENDPOINT, 'GET');
      return response;
    } catch (error) {
      console.error("API Service - addRole error:", error);
      throw error;
    }
  }

  static async deleteRole(roleId: string): Promise<APIResponseType> {
    if (!roleId) throw new Error("Role ID is required for deletion");
    try {
      const response = await apiService.delete<APIResponseType>(`${this.ENDPOINT}/${roleId}`);
      await apiService.invalidateCacheByPrefix(this.ENDPOINT, 'GET');
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async editRole(roleId: string, payload: Partial<RolePayload>): Promise<APIResponseType> {
    if (!roleId) throw new Error("Role ID is required for editing");
    if (!Object.keys(payload).length) throw new Error("Edit payload cannot be empty");

    try {
      const response = await apiService.put<APIResponseType>(`${this.ENDPOINT}/${roleId}`, payload);
      await apiService.invalidateCacheByPrefix(this.ENDPOINT, 'GET');
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async getSidebarNavigation(params: {
    old_layout: boolean;
  }): Promise<APIResponseType> {
    try {
      // Only send old_layout to get all available sidebar navigation items
      const queryParams = new URLSearchParams();
      queryParams.append('old_layout', params.old_layout.toString());
      
      const response = await apiService.get<APIResponseType>(`api/v2/sidebar-navigation?${queryParams.toString()}`);
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default Role;
